import produce from 'immer';
import { getAreaOfPolygon } from 'geolib';
import { isUUID } from '../helpers/common';
import { WORK_TYPE_LIST } from '../constants';
import { Unit } from '../helpers/unit';
import {
    mergeCrewSummaryKPI, mergeCrewDonutKPI, mergeCrewGraphKPI, mergeSourceEgKPIData,
    mergeCrewLoad, getDefaultTargetAndSourceEgDetails, getWorkedAcres, isMergeWorkElasticData
} from '../interceptors/dashboard';
import * as actionTypes from '../constants/action-types';
import { HARVESTING_WORK_TYPE_ID } from '../constants';

const defaultState = {
    crew: {
        donut: {
            isRequesting: false,
            payload: {
                total_duration: { h: 24, m: 0 },
                planned_work: { h: 0, m: 0 },
                planned_utilization: { h: 0, m: 0 },
                actual_work: { h: 0, m: 0 },
                actual_utilization: { h: 0, m: 0 },
                total_duration_percentage: 100,
                planned_work_percentage: 0,
                planned_utilization_percentage: 0,
                actual_work_percentage: 0,
                actual_utilization_percentage: 0,
                utilization: 0,
                crew_count: 0,
                equipment_group_count: 0,
                work_in_progress: true,
                start_date: null,
                end_date: null
            }
        },
        summary: {
            isRequesting: false,
            payload: {
                acres: { planned: 0, completed: 0, remaining: 0 },
                hours: { planned: { h: 0, m: 0 }, completed: { h: 0, m: 0 }, remaining: { h: 0, m: 0 } },
                load: { total_loads: 0, avg_roundtrip_load_time: { h: 0, m: 0 } },
                start_date: null,
                end_date: null
            }
        },
        graph: {
            isRequesting: false,
            payload: {
                planned: [],
                actual: [],
                trend: [],
                planned_activity: []
            }
        },
        elasticWork: {
            isRequesting: false,
            payload: {
                isLive: false,
                data: null
            }
        },
        elasticLoad: {
            isRequesting: false,
            payload: {
                isLive: false,
                data: null
            }
        }
    }
};

const initialState = {
    defaultState,
    farmId: null,
    activeTab: null,
    collapseLeaderBoard: false,
    refreshCount: 0,
    planTypeList: {
        isRequesting: false,
        payload: []
    },
    workTypeList: {
        isRequesting: false,
        payload: WORK_TYPE_LIST
    },
    leaderBoard: {
        selectedWorkTypeIds: [1, 2, 3, 4, 5, 9],
        egList: {
            isRequesting: false,
            payload: []
        },
        sourceListById: {
            isRequestingKpi: false,
            isRequestingLoad: false,
            payload: {}
        },
        targetListById: {
            isRequestingLoad: false,
            payload: {}
        },
        egWiseSpeed: {}
    },
    crew: {
        selectedPlanTypeIds: [],
        selectedCrewIds: [],
        includeEndedCrew: false,
        crewListById: {
            isRequesting: false,
            payload: {},
            filteredPayload: {}
        },
        analyseById: {}
    },
    field: {
        selectedWorkTypeIds: [2],
        isManualSelect: false,
        autoSelectedFieldIds: [],
        selectedFieldIds: [],
        activeList: [],
        inActiveList: [],
        workedFields: [],
        sortBy: { name: 'percentage', type: 'desc', label: 'Completed % - (99% to 0%)' },
        egListById: {
            isRequesting: false,
            payload: {}
        },
        fieldListById: {
            isRequesting: false,
            payload: {}
        },
        workedAcresById: {
            isRequesting: false,
            payload: {},
            request: {}
        },
        egWorkedById: {},
        fieldLoads: {
            isRequesting: false,
            payload: []
        },
        fieldFilter: {
            fields: [],
            crops: []
        },
        fieldHistory: {
            isRequesting: false,
            payload: []
        }
    },
    offload: {
        list: {
            isRequesting: false,
            payload: []
        },
        report: {
            isRequesting: false,
            payload: []
        },
        details: {
            isRequesting: false,
            requestingShapeIds: [],
            payload: {}
        }
    },
    loads: {
        chartViewType: 1,
        viewId: 0,
        subViewId: 2,
        viewTypes: [
            { id: 0, name: "Total Loads", icon: "fa fa-truck", primaryColor: '#061a31', secondaryColor: '#0b3261', keyName: null },
            { id: 1, name: "Fields", icon: "fa fa-map-o", primaryColor: '#1a9e58', secondaryColor: '#38af6f', keyName: 'fieldGeoShapeId' },
            { id: 2, name: "Implement", icon: "fa fa-link", primaryColor: '#c28e15', secondaryColor: '#eb9f13', keyName: 'sourceEquipmentGroupId' },
            { id: 3, name: "Transport", icon: "fa fa-bus", primaryColor: '#943625', secondaryColor: '#cc5742', keyName: 'targetEquipmentGroupId' },
            { id: 4, name: "Offload site", icon: "fa fa-university", primaryColor: '#14aeb9', secondaryColor: '#2fceda', keyName: 'offloadGeoShapeId' }
        ],
        namesById: {},
        loadHistory: {
            isRequesting: false,
            payload: [],
            loadSequenceData: [],
            dynamicLoadGraphData: []
        }
    },
    requestIds: [],
    harvestSummary: {
        isRequesting: false,
        payload: {}
    },
    userRemember: {
        isRequesting: false,
        payload: {}
    },
    tareLoadHistory: {
        isRequesting: false,
        data: [],
        loadDetails: {
            totalCount: 0,
            totalCapacity: 0,
            totalLoadSeconds: 0
        },
        totalLoadTripCount: 0
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        //COMMON
        case actionTypes.DASHBOARD_SET_FARM_ID: {
            if (!action.farmId) break;
            state = {
                ...state,
                farmId: action.farmId
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_PLAN_TYPE_LIST: {
            const { payload } = action;
            const activePlanType = payload ? payload.map(e => e.plan_type_id) : [];

            state = {
                ...state,
                planTypeList: {
                    isRequesting: false,
                    payload: payload ? payload : initialState.planTypeList.payload
                },
                crew: {
                    ...state.crew,
                    selectedPlanTypeIds: state.crew.selectedPlanTypeIds.length === 0
                        ? activePlanType : state.crew.selectedPlanTypeIds,
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_SET_ACTIVE_TAB: {
            if (!action.activeTab) break;
            state = {
                ...state,
                activeTab: action.activeTab
            };
            break;
        }
        case actionTypes.DASHBOARD_ADD_REQUEST_ID: {
            state = {
                ...state,
                requestIds: [...state.requestIds, action.requestId]
            };
            break;
        }
        case actionTypes.DASHBOARD_CLEAR_REQUEST_IDS: {
            state = {
                ...state,
                requestIds: []
            };
            break;
        }
        case actionTypes.DASHBOARD_REFRESH: {
            state = {
                ...state,
                refreshCount: state.refreshCount + 1
            };
            break;
        }
        case actionTypes.DASHBOARD_CLEAR: {
            state = {
                ...initialState,
                ...!action.clearAll && {
                    farmId: state.farmId,
                    collapseLeaderBoard: state.collapseLeaderBoard,
                    leaderBoard: {
                        ...initialState.leaderBoard,
                        selectedWorkTypeIds: state.leaderBoard.selectedWorkTypeIds
                    },
                    crew: {
                        ...initialState.crew,
                        selectedPlanTypeIds: state.crew.selectedPlanTypeIds,
                        selectedCrewIds: state.crew.selectedCrewIds
                    },
                    field: {
                        ...initialState.field,
                        isManualSelect: state.field.isManualSelect,
                        selectedWorkTypeIds: state.field.selectedWorkTypeIds,
                        selectedFieldIds: state.field.selectedFieldIds
                    },
                    loads: {
                        ...initialState.loads,
                        viewId: state.loads.viewId,
                        subViewId: state.loads.subViewId
                    }
                }
            };
            break;
        }

        //LEADER BOARD
        case actionTypes.DASHBOARD_SET_COLLAPSE_LEADER_BOARD: {
            state = {
                ...state,
                collapseLeaderBoard: !state.collapseLeaderBoard
            };
            break;
        }
        case actionTypes.DASHBOARD_SET_SELECTED_WORK_TYPE_LEADERBOARD: {
            state = {
                ...state,
                leaderBoard: {
                    ...state.leaderBoard,
                    selectedWorkTypeIds: action.payload,
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_EG_LIST_REQUEST: {
            state = {
                ...state,
                leaderBoard: {
                    ...state.leaderBoard,
                    egList: {
                        isRequesting: action.isRequest,
                        payload: []
                    },
                    sourceListById: {
                        isRequestingKpi: false,
                        isRequestingLoad: false,
                        payload: {}
                    },
                    targetListById: {
                        isRequestingLoad: false,
                        payload: {}
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_EG_LIST: {
            const { payload } = action;
            const egList = payload ? payload : [];
            const { sourceDetailsById, targetDetailsById } = getDefaultTargetAndSourceEgDetails(egList);

            let egListWorkType = [];
            egList.forEach(item => {
                if (egListWorkType.indexOf(item.work_type_id) >= 0) return;
                else egListWorkType.push(item.work_type_id);
            });

            const newActiveWorkType = state.leaderBoard.selectedWorkTypeIds.filter(id => egListWorkType.indexOf(id) >= 0);

            state = {
                ...state,
                leaderBoard: {
                    ...state.leaderBoard,
                    selectedWorkTypeIds: newActiveWorkType,
                    egList: {
                        isRequesting: false,
                        payload: egList
                    },
                    sourceListById: {
                        ...state.leaderBoard.sourceListById,
                        payload: sourceDetailsById
                    },
                    targetListById: {
                        ...state.leaderBoard.targetListById,
                        payload: targetDetailsById
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_MANUAL_LOAD_REQUEST_FOR_LEADERBOARD: {
            const listType = action.loadType === "source" ? "sourceListById" : "targetListById";

            state = {
                ...state,
                leaderBoard: {
                    ...state.leaderBoard,
                    [listType]: {
                        ...state.leaderBoard[listType],
                        isRequestingLoad: true
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_MANUAL_LOAD_FOR_LEADERBOARD: {
            let listById = null;
            let listType = null;
            if (action.loadType === "source") {
                listType = "sourceListById";

                listById = state.leaderBoard.sourceListById.payload;
                if (action.payload) action.payload.forEach(e => {
                    if (!listById[e.equipment_group_uuid]) return;
                    listById[e.equipment_group_uuid].loadCount = e.load_count;
                    listById[e.equipment_group_uuid].loadCapacity = e.load_capacity;
                });
            }
            if (action.loadType === "target") {
                listType = "targetListById";
                listById = state.leaderBoard.targetListById.payload;

                if (action.payload) action.payload.forEach(e => {
                    if (!listById[e.equipment_group_uuid]) return;
                    listById[e.equipment_group_uuid].loadCount = e.load_count;
                    listById[e.equipment_group_uuid].avgLoadSeconds = e.avg_load_seconds;
                    listById[e.equipment_group_uuid].avgRoundTripSeconds = e.avg_round_trip_load_seconds;
                    listById[e.equipment_group_uuid].loadCapacity = e.load_capacity;
                });
            }

            state = {
                ...state,
                leaderBoard: {
                    ...state.leaderBoard,
                    [listType]: {
                        ...state.leaderBoard[listType],
                        isRequestingLoad: false,
                        payload: listById
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_AUTOMATIC_EG_LOAD_REQUEST: {
            state = {
                ...state,
                leaderBoard: {
                    ...state.leaderBoard,
                    sourceListById: {
                        ...state.leaderBoard.sourceListById,
                        isRequestingLoad: true
                    },
                    targetListById: {
                        ...state.leaderBoard.targetListById,
                        isRequestingLoad: true
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_AUTOMATIC_EG_LOAD: {
            const targetDetailsById = state.leaderBoard.targetListById.payload;
            const sourceDetailsById = state.leaderBoard.sourceListById.payload;

            action.payload && Object.keys(action.payload.data).forEach(id => {
                const item = action.payload.data[id];
                if (targetDetailsById[id]) {
                    if (item.load_count > 0) targetDetailsById[id].loadCount = item.load_count;
                    if (item.round_trip_seconds > 0) targetDetailsById[id].avgRoundTripSeconds = item.round_trip_seconds;
                }
                else if (sourceDetailsById[id]) {
                    if (item.load_count > 0) sourceDetailsById[id].loadCount = item.load_count;
                }
            });

            state = {
                ...state,
                leaderBoard: {
                    ...state.leaderBoard,
                    sourceListById: {
                        ...state.leaderBoard.sourceListById,
                        isRequestingLoad: false,
                        payload: sourceDetailsById
                    },
                    targetListById: {
                        ...state.leaderBoard.targetListById,
                        isRequestingLoad: false,
                        payload: targetDetailsById
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_SOURCE_EG_ELASTIC_DATA_REQUEST: {
            state = {
                ...state,
                leaderBoard: {
                    ...state.leaderBoard,
                    sourceListById: {
                        ...state.leaderBoard.sourceListById,
                        isRequestingKpi: true
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_SOURCE_EG_ELASTIC_DATA: {
            const { payload } = action;
            const sourceDetailsById = state.leaderBoard.sourceListById.payload;

            for (const egId in payload) {
                if (!sourceDetailsById[egId]) continue;

                const { acres, utilization, utilizationPerDay } = mergeSourceEgKPIData({ [egId]: payload[egId] }, action.range);
                if (acres > 0) sourceDetailsById[egId].acres = acres;
                if (utilization > 0) sourceDetailsById[egId].utilization = utilization;
                sourceDetailsById[egId].utilizationPerDay = utilizationPerDay;
            }

            state = {
                ...state,
                leaderBoard: {
                    ...state.leaderBoard,
                    sourceListById: {
                        ...state.leaderBoard.sourceListById,
                        isRequestingKpi: false,
                        payload: sourceDetailsById
                    }
                }
            };
            break;
        }

        //CREWS
        case actionTypes.DASHBOARD_SET_SELECTED_PLAN_TYPE_FOR_CREW: {
            state = {
                ...state,
                crew: {
                    ...state.crew,
                    selectedPlanTypeIds: action.payload,
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_SET_SELECTED_CREWS: {
            if (!action.payload) break;
            state = {
                ...state,
                crew: {
                    ...state.crew,
                    selectedCrewIds: action.payload,
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_CREW_LIST_REQUEST: {
            state = {
                ...state,
                crew: {
                    ...state.crew,
                    analyseById: {},
                    crewListById: {
                        isRequesting: true,
                        payload: {},
                        filteredPayload: {}
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_CREW_LIST: {
            const { payload } = action;
            let { selectedCrewIds } = state.crew;

            const sortedList = payload
                ? payload.map(item => {
                    const display_order = (item.alive && !item.is_end_crew) ? 1 : ((item.alive && item.is_end_crew) ? 2 : 3);
                    return { ...item, display_order };
                }).sort((a, b) => a.display_order - b.display_order)
                : [];

            const crewListById = {};
            sortedList.forEach(e => { crewListById[e.crew_uuid] = e; });

            const crewRemember = state.userRemember.payload && state.userRemember.payload.crews &&
                state.userRemember.payload.crews.length > 0 ? state.userRemember.payload.crews : []

            let newSelectedCrewIds = [];
            if (crewRemember && crewRemember.length > 0) {
                let filterCrewRememberByPlanTypeId = [];
                crewRemember.forEach((each) => {
                    if (crewListById[each.id]) {
                        filterCrewRememberByPlanTypeId.push(each);
                    }
                })
                if (filterCrewRememberByPlanTypeId.length > 0) {
                    newSelectedCrewIds = [...filterCrewRememberByPlanTypeId.sort((a, b) => a.display_order - b.display_order).map(e => e.id)];
                } else {
                    newSelectedCrewIds = sortedList.filter(e1 => e1.display_order === 1).filter((e2, i) => i <= 5).map(item => item.crew_uuid);
                }
            } else {
                if (!selectedCrewIds || selectedCrewIds.length === 0)

                    newSelectedCrewIds = sortedList.filter(e1 => e1.display_order === 1).filter((e2, i) => i <= 5).map(item => item.crew_uuid);
                else selectedCrewIds.forEach(id => {
                    if (Object.keys(crewListById).indexOf(id) >= 0) newSelectedCrewIds = [...newSelectedCrewIds, id];
                });
            }

            let crewListPlanType = [];

            sortedList.forEach(item => {
                if (crewListPlanType.indexOf(item.plan_type_id) >= 0) return;
                else crewListPlanType.push(item.plan_type_id);
            });

            const newSelectedPlanTypeIds = state.crew.selectedPlanTypeIds.filter(id => crewListPlanType.indexOf(id) >= 0);

            //in order to filter ended crew
            let filteredCrewListById = {};
            if (Object.keys(crewListById).length > 0) {
                const crewList = Object.keys(crewListById)
                    .map(id => crewListById[id])
                    .filter(item => state.crew.includeEndedCrew ? true : !item.is_end_crew);
                crewList.forEach(e => { filteredCrewListById[e.crew_uuid] = e; });
            }

            state = {
                ...state,
                crew: {
                    ...state.crew,
                    selectedCrewIds: newSelectedCrewIds,
                    selectedPlanTypeIds: newSelectedPlanTypeIds,
                    crewListById: {
                        isRequesting: false,
                        payload: crewListById,
                        filteredPayload: filteredCrewListById
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_INCLUDE_ENDED_CREW: {
            const { payload } = action;
            const filteredCrewListById = {};
            const crewListById = state.crew.crewListById.payload;

            if (Object.keys(crewListById).length > 0) {
                const crewList = Object.keys(crewListById)
                    .map(id => crewListById[id])
                    .filter(item => payload ? true : !item.is_end_crew);
                crewList.forEach(e => { filteredCrewListById[e.crew_uuid] = e; });
            }

            state = {
                ...state,
                crew: {
                    ...state.crew,
                    includeEndedCrew: payload,
                    crewListById: {
                        ...state.crew.crewListById,
                        filteredPayload: filteredCrewListById
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_CREW_SUMMARY_REQUEST: {
            const { crewId } = action;
            if (!isUUID(crewId)) break;

            state = {
                ...state,
                crew: {
                    ...state.crew,
                    analyseById: {
                        ...state.crew.analyseById,
                        [crewId]: {
                            ...state.crew.analyseById[crewId],
                            summary: {
                                ...initialState.defaultState.crew.summary,
                                isRequesting: true
                            }
                        }
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_CREW_SUMMARY: {
            const { crewId, payload } = action;
            if (!isUUID(crewId)) break;

            let summary = payload ? payload : {};

            if (payload && !payload.hasOwnProperty("load"))
                summary = { ...summary, load: { total_loads: 0, avg_roundtrip_load_time: { h: 0, m: 0 } } };

            state = {
                ...state,
                crew: {
                    ...state.crew,
                    analyseById: {
                        ...state.crew.analyseById,
                        [crewId]: {
                            ...state.crew.analyseById[crewId],
                            summary: {
                                isRequesting: false,
                                payload: {
                                    ...(state.crew.analyseById[crewId].summary && state.crew.analyseById[crewId].summary.payload)
                                        ? state.crew.analyseById[crewId].summary.payload
                                        : initialState.defaultState.crew.summary.payload,
                                    ...summary
                                }
                            }
                        }
                    }
                }
            };

            if (state.crew.analyseById[crewId].elasticWork && state.crew.analyseById[crewId].elasticWork.payload
                && isMergeWorkElasticData(state.crew.analyseById[crewId].elasticWork.payload))
                state = {
                    ...state,
                    crew: {
                        ...state.crew,
                        analyseById: {
                            ...state.crew.analyseById,
                            [crewId]: {
                                ...state.crew.analyseById[crewId],
                                ...mergeCrewSummaryKPI(crewId, state, state.crew.analyseById[crewId].elasticWork.payload, initialState)
                            }
                        }
                    }
                };

            if (state.crew.analyseById[crewId].elasticLoad && state.crew.analyseById[crewId].elasticLoad.payload)
                state = {
                    ...state,
                    crew: {
                        ...state.crew,
                        analyseById: {
                            ...state.crew.analyseById,
                            [crewId]: {
                                ...state.crew.analyseById[crewId],
                                ...mergeCrewLoad(crewId, state, state.crew.analyseById[crewId].elasticLoad.payload)
                            }
                        }
                    }
                };
            break;
        }
        case actionTypes.DASHBOARD_GET_CREW_DONUT_REQUEST: {
            const { crewId } = action;
            if (!isUUID(crewId)) break;

            state = {
                ...state,
                crew: {
                    ...state.crew,
                    analyseById: {
                        ...state.crew.analyseById,
                        [crewId]: {
                            ...state.crew.analyseById[crewId],
                            donut: {
                                ...initialState.defaultState.crew.donut,
                                isRequesting: true
                            }
                        }
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_CREW_DONUT: {
            const { crewId, payload } = action;
            if (!isUUID(crewId)) break;

            state = {
                ...state,
                crew: {
                    ...state.crew,
                    analyseById: {
                        ...state.crew.analyseById,
                        [crewId]: {
                            ...state.crew.analyseById[crewId],
                            donut: {
                                isRequesting: false,
                                payload: {
                                    ...(state.crew.analyseById[crewId].donut && state.crew.analyseById[crewId].donut.payload)
                                        ? state.crew.analyseById[crewId].donut.payload
                                        : initialState.defaultState.crew.donut.payload,
                                    ...payload ? payload : {}
                                }
                            }
                        }
                    }
                }
            };
            if (state.crew.analyseById[crewId].elasticWork && state.crew.analyseById[crewId].elasticWork.payload
                && isMergeWorkElasticData(state.crew.analyseById[crewId].elasticWork.payload))
                state = {
                    ...state,
                    crew: {
                        ...state.crew,
                        analyseById: {
                            ...state.crew.analyseById,
                            [crewId]: {
                                ...state.crew.analyseById[crewId],
                                ...mergeCrewDonutKPI(crewId, state, state.crew.analyseById[crewId].elasticWork.payload)
                            }
                        }
                    }
                };
            break;
        }
        case actionTypes.DASHBOARD_GET_CREW_GRAPH_REQUEST: {
            const { crewId } = action;
            if (!isUUID(crewId)) break;

            state = {
                ...state,
                crew: {
                    ...state.crew,
                    analyseById: {
                        ...state.crew.analyseById,
                        [crewId]: {
                            ...state.crew.analyseById[crewId],
                            graph: {
                                ...initialState.defaultState.crew.graph,
                                isRequesting: true
                            }
                        }
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_CREW_GRAPH: {
            const { crewId, payload, range } = action;
            if (!isUUID(crewId)) break;

            state = {
                ...state,
                crew: {
                    ...state.crew,
                    analyseById: {
                        ...state.crew.analyseById,
                        [crewId]: {
                            ...state.crew.analyseById[crewId],
                            graph: {
                                isRequesting: false,
                                payload: {
                                    ...(state.crew.analyseById[crewId].graph && state.crew.analyseById[crewId].graph.payload)
                                        ? state.crew.analyseById[crewId].graph.payload
                                        : initialState.defaultState.crew.graph.payload,
                                    ...payload ? payload : {}
                                }
                            }
                        }
                    }
                }
            };
            if (state.crew.analyseById[crewId].elasticWork && state.crew.analyseById[crewId].elasticWork.payload
                && isMergeWorkElasticData(state.crew.analyseById[crewId].elasticWork.payload))
                state = {
                    ...state,
                    crew: {
                        ...state.crew,
                        analyseById: {
                            ...state.crew.analyseById,
                            [crewId]: {
                                ...state.crew.analyseById[crewId],
                                ...mergeCrewGraphKPI(crewId, state, state.crew.analyseById[crewId].elasticWork.payload, initialState, range, action.timezone)
                            }
                        }
                    }
                };
            break;
        }
        case actionTypes.DASHBOARD_GET_CREW_ELASTIC_DATA_REQUEST: {
            const { crewId, elasticType } = action;
            if (!isUUID(crewId)) break;

            state = {
                ...state,
                crew: {
                    ...state.crew,
                    analyseById: {
                        ...state.crew.analyseById,
                        [crewId]: {
                            ...state.crew.analyseById[crewId],
                            ...elasticType === "work" && {
                                elasticWork: {
                                    ...(state.crew.analyseById[crewId] && state.crew.analyseById[crewId].elasticWork)
                                        ? state.crew.analyseById[crewId].elasticWork
                                        : initialState.defaultState.crew.elasticWork,
                                    isRequesting: true
                                }
                            },
                            ...elasticType === "load" && {
                                elasticLoad: {
                                    ...(state.crew.analyseById[crewId] && state.crew.analyseById[crewId].elasticLoad)
                                        ? state.crew.analyseById[crewId].elasticLoad
                                        : initialState.defaultState.crew.elasticLoad,
                                    isRequesting: true
                                }
                            }
                        }
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_CREW_ELASTIC_DATA: {
            const { crewId, elasticType, elastic, range } = action;
            if (!isUUID(crewId) || !state.crew.analyseById[crewId]) break;

            state = {
                ...state,
                crew: {
                    ...state.crew,
                    analyseById: {
                        ...state.crew.analyseById,
                        [crewId]: {
                            ...state.crew.analyseById[crewId],
                            ...elasticType === "work" && {
                                elasticWork: {
                                    isRequesting: false,
                                    payload: {
                                        ...(state.crew.analyseById[crewId] && state.crew.analyseById[crewId].elasticWork)
                                            ? state.crew.analyseById[crewId].elasticWork.payload
                                            : initialState.defaultState.crew.elasticWork.payload,
                                        ...elastic ? elastic : {}
                                    }
                                }
                            },
                            ...elasticType === "load" && {
                                elasticLoad: {
                                    isRequesting: false,
                                    payload: {
                                        ...(state.crew.analyseById[crewId] && state.crew.analyseById[crewId].elasticLoad)
                                            ? state.crew.analyseById[crewId].elasticLoad.payload
                                            : initialState.defaultState.crew.elasticLoad.payload,
                                        ...elastic ? elastic : {}
                                    }
                                }
                            }
                        }
                    }
                }
            };

            if (!elastic) break;
            if (elasticType === "work" && elastic.data && isMergeWorkElasticData(elastic)) {
                state = {
                    ...state,
                    crew: {
                        ...state.crew,
                        analyseById: {
                            ...state.crew.analyseById,
                            [crewId]: {
                                ...state.crew.analyseById[crewId],
                                ...mergeCrewSummaryKPI(crewId, state, state.crew.analyseById[crewId].elasticWork.payload, initialState)
                            }
                        }
                    }
                };
                state = {
                    ...state,
                    crew: {
                        ...state.crew,
                        analyseById: {
                            ...state.crew.analyseById,
                            [crewId]: {
                                ...state.crew.analyseById[crewId],
                                ...mergeCrewDonutKPI(crewId, state, state.crew.analyseById[crewId].elasticWork.payload)
                            }
                        }
                    }
                };
                state = {
                    ...state,
                    crew: {
                        ...state.crew,
                        analyseById: {
                            ...state.crew.analyseById,
                            [crewId]: {
                                ...state.crew.analyseById[crewId],
                                ...mergeCrewGraphKPI(crewId, state, state.crew.analyseById[crewId].elasticWork.payload, initialState, range, action.timezone)
                            }
                        }
                    }
                };
            }

            if (elasticType === "load" && elastic.data) {
                state = {
                    ...state,
                    crew: {
                        ...state.crew,
                        analyseById: {
                            ...state.crew.analyseById,
                            [crewId]: {
                                ...state.crew.analyseById[crewId],
                                ...mergeCrewLoad(crewId, state, state.crew.analyseById[crewId].elasticLoad.payload)
                            }
                        }
                    }
                };
            }
            break;
        }

        //FIELDS
        case actionTypes.DASHBOARD_SET_SELECTED_WORK_TYPE_FOR_FIELD: {
            if (!action.payload) break;
            state = {
                ...state,
                field: {
                    ...state.field,
                    selectedWorkTypeIds: action.payload
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_SET_SELECTED_FIELDS: {
            if (!action.payload) break;
            state = {
                ...state,
                field: {
                    ...state.field,
                    isManualSelect: true,
                    selectedFieldIds: action.payload
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_SET_FILTERED_FIELDS: {
            if (!action.payload) break;
            state = {
                ...state,
                field: {
                    ...state.field,
                    fieldFilter: action.payload
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_SET_SORT_BY: {
            if (!action.payload) break;
            state = {
                ...state,
                field: {
                    ...state.field,
                    sortBy: action.payload
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_EG_LIST_REQUEST_FOR_FIELD: {
            state = {
                ...state,
                field: {
                    ...state.field,
                    egListById: {
                        isRequesting: action.isRequest,
                        payload: {}
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_EG_LIST_FOR_FIELD: {
            const { payload } = action;
            const egListById = {};

            if (payload) payload.forEach(e => { egListById[e.equipment_group_uuid] = e; });
            state = {
                ...state,
                field: {
                    ...state.field,
                    egListById: {
                        isRequesting: false,
                        payload: egListById
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_REGION_LIST_REQUEST: {
            state = {
                ...state,
                field: {
                    ...state.field,
                    fieldListById: {
                        isRequesting: true,
                        payload: {}
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_REGION_LIST: {
            const data = action.payload;
            // let { selectedFieldIds } = state.field;

            const payload = data.filter(e => e.alive);
            const unit = Unit.getInstance();

            let fieldListById = {};
            if (payload) payload.forEach(item => {
                item.shapes && item.shapes.forEach(e => {
                    const setOfLocation = (e.geo_shape_type === "polygon" && e.location)
                        ? e.location.map(points => [points.lng, points.lat]) : [];
                    const workStatus = Array.isArray(e.work_status)
                        ? e.work_status.filter(x => x.work_type_id === HARVESTING_WORK_TYPE_ID) : [];
                    const lastWorkStatus = workStatus.length > 0
                        ? workStatus[workStatus.length - 1]
                        : {
                            work_type_id: HARVESTING_WORK_TYPE_ID,
                            work_status: 1,
                            work_status_date: item.start_date
                        };
                    const totalAcres = unit.toArea(getAreaOfPolygon(setOfLocation) * 0.000247105, 2);
                    const regionDetails = { ...item, totalAcres };
                    delete regionDetails.shapes;
                    fieldListById[e.geo_shape_uuid] = { ...e, regionDetails, lastWorkStatus };
                });
            });

            const geoFieldList = Object.entries(fieldListById).map(([_, item]) => item);

            const activeList = geoFieldList.filter(e => e.lastWorkStatus.work_status === 1).map(e => e.geo_shape_uuid);
            const inActiveList = geoFieldList.filter(e => e.lastWorkStatus.work_status === 4).map(e => e.geo_shape_uuid);

            let newSelectedFieldIds = [];

            newSelectedFieldIds = [...activeList, ...inActiveList];

            state = {
                ...state,
                field: {
                    ...state.field,
                    autoSelectedFieldIds: newSelectedFieldIds,
                    selectedFieldIds: newSelectedFieldIds,
                    activeList,
                    inActiveList,
                    fieldListById: {
                        isRequesting: false,
                        payload: fieldListById
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_WORKED_ACRES_REQUEST: {
            state = {
                ...state,
                field: {
                    ...state.field,
                    workedAcresById: {
                        isRequesting: true,
                        payload: {},
                        request: action.payload
                    },
                    egWorkedById: {}
                }
            };
            break;
        }

        case actionTypes.DASHBOARD_GET_WORKED_ACRES: {
            const { payload, range } = action;
            const unit = Unit.getInstance();

            const fieldListById = state.field.fieldListById.payload;
            let workedAcresById = {};

            payload && payload.data && Array.isArray(payload.data) && payload.data.forEach(item => {
                const filteredIds = Object.keys(fieldListById).filter(id => fieldListById[id].regionDetails.geo_region_uuid === item.geo_region_uuid);
                const { workedAcres, isLinearAcres } = getWorkedAcres(item, range);

                for (const shapeId of filteredIds) {
                    const totalAcres = fieldListById[shapeId].regionDetails.totalAcres;
                    const percentage = (workedAcres > 0 && totalAcres > 0) ?
                        unit.toFixedOf((workedAcres / totalAcres) * 100, 2) : 0;

                    workedAcresById[`${shapeId}_${item.work_type_id}`] = {
                        workedAcres,
                        isLinearAcres,
                        percentage,
                        startDate: null,
                        endDate: null
                    };
                }
            });

            const filteredZeroListIds = Object.keys(workedAcresById).filter(id => workedAcresById[id].percentage === 0);
            const filteredNonZeroListIds = Object.keys(workedAcresById).filter(id => workedAcresById[id].percentage !== 0);

            filteredNonZeroListIds.sort((a, b) => workedAcresById[b].percentage - workedAcresById[a].percentage);
            const sortedListIds = [...filteredNonZeroListIds, ...filteredZeroListIds];

            let workTypeListIds = [];
            let workedActiveList = [];
            let workedInActiveList = [];
            let newSelectedFieldIds = [];
            let activeWorkedFields = [];
            let activeList = state.field.activeList;
            let inActiveList = state.field.inActiveList;

            WORK_TYPE_LIST.forEach(item => {
                if (item.list) item.list.forEach(item => workTypeListIds.push(item.work_type_id));
                else workTypeListIds.push(item.work_type_id);
            });

            if (!state.field.isManualSelect) {
                if (!payload || !payload.data || payload.data.length === 0)
                    newSelectedFieldIds = Object.keys(fieldListById);
                else {
                    const filteredList = sortedListIds.filter(id => workTypeListIds.indexOf(parseInt(id.split("_")[1])) >= 0);

                    filteredList.forEach(id => {
                        if (activeWorkedFields.indexOf(id.split("_")[0]) < 0) activeWorkedFields.push(id.split("_")[0])
                    });

                    filteredList.forEach(id => {
                        const activeIndex = activeList.indexOf(id.split("_")[0]);
                        const inActiveIndex = inActiveList.indexOf(id.split("_")[0]);

                        if (activeIndex >= 0) {
                            workedActiveList.push(activeList[activeIndex]);
                            activeList.splice(activeIndex, 1);
                        }

                        if (inActiveIndex >= 0) {
                            workedInActiveList.push(inActiveList[inActiveIndex]);
                            inActiveList.splice(inActiveIndex, 1);
                        }
                    });
                }
                newSelectedFieldIds = [...workedActiveList, ...activeList, ...workedInActiveList, ...inActiveList];
            }

            let sortedListById = {};
            sortedListIds.forEach(id => sortedListById[id] = workedAcresById[id]);

            state = {
                ...state,
                field: {
                    ...state.field,
                    ...!state.field.isManualSelect && {
                        autoSelectedFieldIds: newSelectedFieldIds,
                        selectedFieldIds: newSelectedFieldIds,
                        // workedFields: activeWorkedFields,
                        workedFields: workedActiveList,
                        activeList: [...workedActiveList, ...activeList],
                        inActiveList: [...workedInActiveList, ...inActiveList],
                    },
                    workedAcresById: {
                        ...state.field.workedAcresById,
                        isRequesting: false,
                        payload: sortedListById,
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_EG_WORED_ACRES_REQUEST: {
            const { shapeRefId, workTypeIds } = action;
            if (!isUUID(shapeRefId)) break;

            const requestedWorkTypeIds = workTypeIds ? workTypeIds : state.field.selectedWorkTypeIds;
            let listById = {};

            requestedWorkTypeIds.forEach(id => {
                listById[`${shapeRefId}_${id}`] = {
                    isRequesting: true,
                    payload: []
                };
            });

            state = {
                ...state,
                field: {
                    ...state.field,
                    egWorkedById: {
                        ...state.field.egWorkedById,
                        ...listById
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_EG_WORED_ACRES: {
            const { shapeRefId, shapeGroupId, workTypeIds, payload } = action;
            if (!isUUID(shapeRefId)) break;

            const requestedWorkTypeIds = workTypeIds ? workTypeIds : state.field.selectedWorkTypeIds;
            let listById = {};

            requestedWorkTypeIds.forEach(id => {
                listById[`${shapeRefId}_${id}`] = {
                    isRequesting: false,
                    workTypeId: id,
                    payload: []
                };
            });

            if (payload && payload.data && payload.data[shapeGroupId]) {
                Object.keys(payload.data[shapeGroupId]).forEach(id => {
                    payload.data[shapeGroupId][id].forEach(item => {
                        listById[`${shapeRefId}_${item.work_type_id}`] = {
                            ...listById[`${shapeRefId}_${item.work_type_id}`],
                            payload: [...listById[`${shapeRefId}_${item.work_type_id}`].payload, item]
                        };
                    });
                });
            };

            state = {
                ...state,
                field: {
                    ...state.field,
                    egWorkedById: {
                        ...state.field.egWorkedById,
                        ...listById
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_FIELD_LOADS_REQUEST:
            state = {
                ...state, field: {
                    ...state.field,
                    fieldLoads: { isRequesting: true, payload: initialState.field.fieldLoads.payload }
                }
            };
            break;
        case actionTypes.DASHBOARD_GET_FIELD_LOADS: {
            const payload = action.payload || initialState.field.fieldLoads.payload;
            state = {
                ...state, field: {
                    ...state.field,
                    fieldLoads: { isRequesting: false, payload: payload }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_FIELD_LOADS_TODATE_REQUEST:
            state = {
                ...state, field: {
                    ...state.field,
                    fieldHistory: {
                        isRequesting: true,
                        payload: initialState.field.fieldHistory.payload
                    }
                }
            };
            break;
        case actionTypes.DASHBOARD_GET_FIELD_LOADS_TODATE: {
            const payload = action.payload || initialState.field.fieldHistory.payload;
            state = {
                ...state, field: {
                    ...state.field,
                    fieldHistory: {
                        isRequesting: false,
                        payload: payload
                    }
                }
            };
            break;
        }

        // OFFLOAD

        case actionTypes.DASHBOARD_SET_OFFLOAD_REQUEST: {
            state = {
                ...state, offload: {
                    ...state.offload,
                    list: {
                        ...state.offload.list,
                        isRequesting: true
                    }
                }
            };
            break;
        }

        case actionTypes.DASHBOARD_SET_OFFLOAD_LIST: {
            const payload = action.payload || initialState.offload.list.payload;
            state = {
                ...state, offload: {
                    ...state.offload,
                    list: {
                        payload, isRequesting: false
                    }
                }
            };
            break;
        }

        case actionTypes.DASHBOARD_SET_OFFLOAD_REPORT_REQUEST: {
            state = {
                ...state, offload: {
                    ...state.offload,
                    report: {
                        ...state.offload.report,
                        isRequesting: true
                    }
                }
            };
            break;
        }

        case actionTypes.DASHBOARD_SET_OFFLOAD_REPORT: {
            const payload = action.payload || initialState.offload.report.payload;
            state = {
                ...state, offload: {
                    ...state.offload,
                    report: {
                        payload, isRequesting: false
                    }
                }
            };
            break;
        }

        case actionTypes.DASHBOARD_SET_OFFLOAD_DETAILS_REQUEST: {
            const regionShapeIds = ((action.payload || {}).geo_region_shape_uuid || '').split(',');
            state = produce(state, s => {
                s.offload.details.isRequesting = true;
                s.offload.details.requestingShapeIds = regionShapeIds;
            });
            break;
        }

        case actionTypes.DASHBOARD_SET_OFFLOAD_DETAILS: {
            const { data, geo_region_shape_uuid } = action.payload;
            state = produce(state, s => {
                s.offload.details.isRequesting = false;
                s.offload.details.requestingShapeIds = [];
                s.offload.details.payload[geo_region_shape_uuid] = {
                    storageList: (data.storage_list || []).map(storage => ({
                        geoStorageLocationId: storage.geo_storage_location_uuid,
                        totalCapacity: storage.total_capacity || 0,
                        filledCapacity: storage.filled_capacity || 0,
                        selectedFilledCapacity: storage.selected_range_filled_capacity || 0,
                        availableCapacity: storage.available_capacity || 0,
                        totalLoad: storage.total_load || 0,
                        selectedTotalLoad: storage.total_selected_range_load || 0
                    })),
                    summary: {
                        totalCapacity: data.summary.total_capacity || 0,
                        totalCapacityWithoutUnknown: data.summary.total_loads_without_unknown || 0,
                        filledCapacity: data.summary.filled_capacity || 0,
                        filledCapacityWithoutUnknown: data.summary.filled_capacity_without_unknown || 0,
                        selectedFilledCapacity: data.summary.selected_range_filled_capacity || 0,
                        selectedFilledCapacityWithUnknown: data.summary.selected_range_filled_capacity_without_unknown || 0,
                        availableCapacity: data.summary.available_capacity || 0,
                        // loads
                        totalLoads: data.summary.total_loads || 0,
                        totalLoadsWithoutUnknown: data.summary.total_loads_without_unknown || 0,
                        selectedTotalLoads: data.summary.total_selected_range_loads || 0,
                        selectedTotalLoadsWithoutUnknown: data.summary.total_selected_range_loads_without_unknown || 0,
                        load_start_date: data.summary.load_start_date || "",
                        load_end_date: data.summary.load_end_date || ""
                    }
                };
            });
            break;
        }

        //LOADS
        case actionTypes.DASHBOARD_SET_CHART_VIEW_TYPE: {
            state = {
                ...state,
                loads: {
                    ...state.loads,
                    chartViewType: action.payload
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_SET_SELECTED_LOAD_MAIN_VIEW: {
            const list = state.loads.viewTypes.filter(item => item.id !== action.payload);
            const { dynamicLoadGraphData } = state.loads.loadHistory;
            let loadData = [];
            if (action.payload === 1 || action.payload === 2) {
                if (dynamicLoadGraphData.length > 0) {
                    dynamicLoadGraphData.forEach((load) => {
                        if (action.payload === 1) {
                            const payload = {
                                loadDate: load.created_date_tz,
                                loadCapacity: load.load_capacity,
                                sourceEquipmentGroupId: load.source_equipment_group_uuid,
                                sourceEquipmentGroupName: load.source_equipment_group_name,
                                targetEquipmentGroupId: load.target_equipment_group_uuid,
                                targetEquipmentGroupName: load.target_equipment_group_name,
                                fieldGeoShapeId: load.geo_shape_uuid,
                                fieldGeoRegionName: load.geo_shape_name,
                            }
                            loadData.push(payload);
                        } else if (action.payload === 2) {
                            const payload = {
                                loadDate: load.created_date_tz,
                                loadCapacity: load.load_capacity,
                                sourceEquipmentGroupId: load.target_equipment_group_uuid,
                                sourceEquipmentGroupName: load.target_equipment_group_name,
                                targetEquipmentGroupId: load.source_equipment_group_uuid,
                                targetEquipmentGroupName: load.source_equipment_group_name,
                                fieldGeoShapeId: load.geo_shape_uuid,
                                fieldGeoRegionName: load.geo_shape_name,
                            }
                            loadData.push(payload);
                        }
                    })
                }
            } else {
                loadData = state.loads.loadHistory.payload;
            }

            state = {
                ...state,
                loads: {
                    ...state.loads,
                    viewId: action.payload,
                    subViewId: list[1].id,
                    loadHistory: {
                        ...state.loads.loadHistory,
                        loadSequenceData: loadData
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_SET_SELECTED_LOAD_SUB_VIEW: {
            state = {
                ...state,
                loads: {
                    ...state.loads,
                    subViewId: action.payload
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_MANUAL_LOAD_REQUEST: {
            state = {
                ...state,
                loads: {
                    ...state.loads,
                    namesById: {},
                    loadHistory: {
                        isRequesting: true,
                        payload: [],
                        loadSequenceData: [],
                        dynamicLoadGraphData: []
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_MANUAL_LOAD: {
            let namesById = {};
            let dynamicLoadGraphData = [];
            action.payload && action.payload.forEach(item => {
                if (!namesById[item.fieldGeoShapeId])
                    namesById[item.fieldGeoShapeId] = item.fieldGeoRegionName;
                if (!namesById[item.offloadGeoShapeId])
                    namesById[item.offloadGeoShapeId] = item.offloadGeoShapeName;
                if (!namesById[item.sourceEquipmentGroupId])
                    namesById[item.sourceEquipmentGroupId] = item.sourceEquipmentGroupName;
                if (!namesById[item.targetEquipmentGroupId])
                    namesById[item.targetEquipmentGroupId] = item.targetEquipmentGroupName;

                if (action.selectedPlanType && action.selectedPlanType === 2) {
                    if (item.loadSequence && item.loadSequence.length > 0) {
                        item.loadSequence.forEach((seq) => {
                            // const payload = {
                            //     loadDate: seq.created_date_tz,
                            //     loadCapacity: seq.load_capacity,
                            //     sourceEquipmentGroupId: seq.source_equipment_group_uuid,
                            //     sourceEquipmentGroupName: seq.source_equipment_group_name,
                            //     targetEquipmentGroupId: seq.target_equipment_group_uuid,
                            //     targetEquipmentGroupName: seq.target_equipment_group_name,
                            //     fieldGeoShapeId: seq.geo_shape_uuid,
                            //     fieldGeoRegionName: seq.geo_shape_name,
                            // }
                            dynamicLoadGraphData.push(seq);
                            if (!namesById[seq.geo_shape_uuid])
                                namesById[seq.geo_shape_uuid] = seq.geo_shape_name;
                            if (!namesById[seq.source_equipment_group_uuid])
                                namesById[seq.source_equipment_group_uuid] = seq.source_equipment_group_name;
                            if (!namesById[seq.target_equipment_group_uuid])
                                namesById[seq.target_equipment_group_uuid] = seq.target_equipment_group_name;
                        })
                    }
                }
            });
            state = {
                ...state,
                loads: {
                    ...state.loads,
                    namesById,
                    loadHistory: {
                        isRequesting: false,
                        payload: action.payload ? action.payload : [],
                        dynamicLoadGraphData
                    }
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_HARVEST_SUMMARY_REQUEST: {
            state = {
                ...state,
                harvestSummary: {
                    payload: {
                        ...state.harvestSummary.payload
                    },
                    isRequesting: true
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_HARVEST_SUMMARY: {
            state = {
                ...state,
                harvestSummary: {
                    ...state.harvestSummary,
                    payload: {
                        ...state.harvestSummary.payload,
                        ...action.payload
                    },
                    isRequesting: false
                }
            };
            break;
        }
        case actionTypes.UPDATE_DASHBOARD_FIELD_WORK_STATUS_SUCCESS: {
            const workStatus = action.payload.work_status;
            const fieldListById = state.field.fieldListById.payload;
            workStatus.forEach(e => {
                let { geo_shape_uuid, work_status, work_status_date } = e;
                if (fieldListById[geo_shape_uuid]) {
                    const fieldItem = fieldListById[geo_shape_uuid];
                    fieldListById[geo_shape_uuid] = {
                        ...fieldItem,
                        lastWorkStatus: { ...fieldItem.lastWorkStatus, work_status, work_status_date }
                    };
                };
            });

            state = produce(state, s => {
                s.field.fieldListById.isRequesting = false;
                s.field.fieldListById.payload = { ...fieldListById };
            });
            break;
        }
        case actionTypes.DASHBOARD_USER_REMEMBER: {
            state = {
                ...state,
                userRemember: {
                    isRequesting: false,
                    payload: action.payload
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_USER_REMEMBER_REQUEST: {
            state = {
                ...state,
                userRemember: {
                    isRequesting: true,
                    payload: null
                }
            };
            break;
        }
        case actionTypes.DASHBOARD_GET_EG_SPEED_REQUEST: {
            const { isRequesting, egId, data } = action.payload;
            const egWiseSpeed = { ...state.leaderBoard.egWiseSpeed };
            egWiseSpeed[egId] = {
                isRequesting,
                speedData: data
            }
            state = { ...state, leaderBoard: { ...state.leaderBoard, egWiseSpeed } }
            break;
        }
        case actionTypes.DASHBOARD_GET_EG_SPEED: {
            const { isRequesting, egId, data } = action.payload;
            const egWiseSpeed = { ...state.leaderBoard.egWiseSpeed };
            egWiseSpeed[egId] = {
                isRequesting,
                speedData: data
            }
            state = { ...state, leaderBoard: { ...state.leaderBoard, egWiseSpeed } }
            break;
        }
        case actionTypes.DASHBOARD_GET_TARE_LOADS_REQUEST: {
            state = produce(state, s => {
                s.tareLoadHistory.isRequesting = true;
                s.tareLoadHistory.data = [];
                s.tareLoadHistory.loadDetails = initialState.tareLoadHistory.loadDetails;
            });
            break;
        }
        case actionTypes.DASHBOARD_GET_TARE_LOADS: {
            const { payload } = action;

            if (!payload) {
                state = produce(state, s => {
                    s.tareLoadHistory = initialState.tareLoadHistory;
                });

                break;
            }

            const loadDetails = {
                totalCount: payload.load.total_count,
                totalCapacity: payload.load.total_capacity,
                totalLoadSeconds: payload.load.total_load_seconds
            }

            state = produce(state, s => {
                s.tareLoadHistory.isRequesting = false;
                s.tareLoadHistory.data = payload.history;
                s.tareLoadHistory.loadDetails = loadDetails;
            });
            break;
        }
        default:
            break;
    };
    return state;
};
